<div class="card">
    <div (click)="click()" class="card-header btn btn-icon btn-{{titleColor}} {{cardHeaderClass}}">
      <span class="w-100 text-left">{{title}}</span>
      <i class="mdi mdi-chevron-down f-28" [ngClass]="{'rotate3d': show}"></i>
    </div>
    <div #cardBodyContainer class="card-container">
      <div #cardBody class="card-body {{cardBodyClass}}">
        <ng-content></ng-content>    
      </div>
    </div>
  </div>